export const Api = "https://pearls-website-back-end.vercel.app/api";
